import Component from './component';
import { query as $ } from '../utils/dom';
import selectors from '../selectors';
import SharingUtil from '../utils/sharing';
import { metadataUrl, metadataTitle } from '../utils/metadata';

export default class Sharing extends Component {
  constructor (props) {
    super(props);

    this.locale = this.props.player.locale;
    this.handleEvent = this.handleEvent.bind(this);
  }

  attach (element) {
    super.attach(element);

    this.$options = this.$(selectors.SelectOptions, element);
    this.$facebook = this.$(selectors.ShareFacebook);
    this.$twitter = this.$(selectors.ShareTwitter);
    this.$whatsapp = this.$(selectors.ShareWhatsApp);

    element.addEventListener('click', this);
    this.props.player.on('playlistselect', this.handleEvent);
  }

  detach () {
    if (!this.$element) return false;

    this.$element.removeEventListener('click', this);

    super.detach();

    document.removeEventListener('click', this);
    this.props.player.off('playlistselect', this.handleEvent);
  }

  show () {
    this.$element.classList.add('iono-open');
    this.$options.focus();
    document.addEventListener('click', this);
  }

  hide () {
    this.$element.classList.remove('iono-open');
    document.removeEventListener('click', this);
  }

  toggle () {
    if (this.$element.classList.contains('iono-open')) {
      this.hide();
    } else {
      this.show();
    }
  }

  handleEvent (event) {
    if (event.type === 'click') {
      if (event.target.matches(selectors.SelectToggle)) {
        event.stopPropagation();
        this.toggle();
      } else {
        this.hide();
      }
    }

    if (event.type === 'playlistselect') {
      const title = metadataTitle(this.props.player);
      const url = metadataUrl(this.props.player);

      this.$facebook.href = SharingUtil.generateFacebookLink(url);
      this.$twitter.href = SharingUtil.generateTwitterLink(url, title);
      this.$whatsapp.href = SharingUtil.generateWhatsAppLink(url, title);
    }
  }
}
